import { render, staticRenderFns } from "./TogglePartnerLogos.vue?vue&type=template&id=05483719&scoped=true&"
import script from "./TogglePartnerLogos.vue?vue&type=script&lang=js&"
export * from "./TogglePartnerLogos.vue?vue&type=script&lang=js&"
import style0 from "./TogglePartnerLogos.vue?vue&type=style&index=0&id=05483719&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05483719",
  null
  
)

export default component.exports